import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar-nav-btn',
  imports: [TranslatePipe],
  templateUrl: './sidebar-nav-btn.html',
  styleUrl: './sidebar-nav-btn.scss',
})
export class SidebarNavBtnComponent {
  path = input<string | undefined>();
  labelKey = input.required<string>();
  icon = input.required<string>();
  isOpen = input.required<boolean>();
  active = input(false);

  navClicked = output<string | undefined>();
}
